import * as React from 'react';
export const clipboardCheckSvg = React.forwardRef(
  function clipboardCheckSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M13.442 10.058a.625.625 0 0 1 0 .884l-2 2a.625.625 0 0 1-.884 0l-1-1a.625.625 0 1 1 .884-.884l.558.558 1.558-1.558a.625.625 0 0 1 .884 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M11.5 14.6a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2Zm0 1.4a4.5 4.5 0 0 0 4.5-4.5C16 9.014 13.992 7 11.5 7a4.5 4.5 0 1 0 0 9Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9 4.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1H2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h4.25a.75.75 0 0 1 0 1.5H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1.17a3.001 3.001 0 0 1 5.66 0H10a2 2 0 0 1 2 2v1.75a.75.75 0 0 1-1.5 0V4a.5.5 0 0 0-.5-.5H9v1Zm-3-3A1.5 1.5 0 0 1 7.5 3v1h-3V3A1.5 1.5 0 0 1 6 1.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3 10.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm0-3A.75.75 0 0 1 3.75 7h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 3 7.75Z',
      }),
    );
  },
);
clipboardCheckSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var clipboardCheck = {
  category: 'icon',
  colorable: true,
  name: 'clipboardCheck',
  svg: clipboardCheckSvg,
};
